/** @jsx jsx */
import { jsx, Box, Container } from "theme-ui";
import SectionHeading from "components/section-heading";
import Service from "components/cards/service";
import icon4 from "assets/images/icons/service4.png";
import icon5 from "assets/images/icons/service5.png";
import icon6 from "assets/images/icons/service6.png";
import icon7 from "assets/images/icons/service7.png";
import icon8 from "assets/images/icons/service8.png";
import icon9 from "assets/images/icons/service9.png";

const data = [
  {
    id: 1,
    icon: icon4,
    title: "Easy installation",
    description: `Equip bins with our solution and connect them our network with the press of a button.`,
  },
  {
    id: 2,
    icon: icon5,
    title: "Height Tracking",
    description: `Let your bin tell you when its full – we check the fullness of bins using ultrasonic sensors so you don’t have to.`,
  },
  {
    id: 3,
    icon: icon6,
    title: "Weight Tracking",
    description: `Get useful stats to guide you in future recycling strategies. By tracking both weight and volume, our solution estimates the type of litter you receive.`,
  },
  {
    id: 4,
    icon: icon7,
    title: "Fire Hazard Prevention",
    description: `Get instant alerts on unusual temperatures to stop smoldering before it can become a safety hazard.`,
  },
  {
    id: 5,
    icon: icon9,
    title: "Intuitive insights in real-time",
    description: `Get helpful information and predictions on your entire bin network.`,
  },
  {
    id: 6,
    icon: icon8,
    title: "Dynamic collection routing",
    description: `Get the optimal route to collect all trash based on current conditions – more efficient journeys and less congested bins.`,
  },
];

const OtherServices = () => {
  return (
    <Box as="section" sx={styles.section}>
      <Container>
        <SectionHeading
          sx={styles.heading}
          title="What we offer"
          description="A fleet of embedded devices to tell you where and when to collect garbage – making the city cleaner while saving you time and resources."
        />
        <Box sx={styles.contentWrapper}>
          {data?.map((item) => (
            <Service key={item.id} item={item} />
          ))}
        </Box>
      </Container>
    </Box>
  );
};
export default OtherServices;

const styles = {
  section: {
    backgroundColor: "#F9FAFC",
    pt: [9, 9, 9, 11],
    pb: [9, 9, 9, 12, 12, 14],
  },
  heading: {
    mb: [6, null, null, 8, 9, null, 13],
    p: {
      maxWidth: 500,
      margin: "10px auto 0",
    },
  },
  contentWrapper: {
    gap: ["30px 30px", "30px 30px", "30px 30px", "80px 30px"],
    display: "grid",
    justifyContent: ["center", "center", "center", "unset"],
    gridTemplateColumns: [
      "repeat(1, 285px)",
      "repeat(1, 325px)",
      "repeat(1, 285px)",
      "repeat(3, 1fr)",
    ],
  },
};
